import { createContext, useEffect, useState } from "react";
import {
  additem,
  getInventory,
  movetoInventory,
  deleteItem,
} from "../utils/inventory-edit";
export const InventoryContext = createContext({});
const UnitsConversion = {
  Kilogram: "Kg",
  Gram: "g",
  Litre: "lt",
};
export const InventoryProvider = ({ children }) => {
  const [inventoryContext, setInventoryContext] = useState({});
  const [toBuyContext, setToBuyContext] = useState({});
  const [unitsContext, setUnitsContext] = useState(UnitsConversion);
  const [wholeInventory, setWholeInventory] = useState({});
  useEffect(() => {
    getInventory(setWholeInventory);
  }, []);
  useEffect(() => {
    if (wholeInventory) {
      var tempToBuyObject = {};
      var tempStockObject = {};
      Object.keys(wholeInventory).map((index) => {
        const tempObject = wholeInventory[index];
        if (tempObject["type"] === "tobuy") {
          tempToBuyObject = { ...tempToBuyObject, [index]: tempObject };
        } else if (tempObject["type"] === "stock") {
          tempStockObject = { ...tempStockObject, [index]: tempObject };
        }
      });
      setToBuyContext(tempToBuyObject);
      setInventoryContext(tempStockObject);
    }
  }, [wholeInventory]);
  const addNewItem = (newItem) => {
    const hotelID = localStorage.getItem("hotelID");
    var tempObject = {
      ...newItem,
      itemName: newItem["name"],
      dateValue: newItem["toBuyDate"],
      hotelID: hotelID,
      type: "tobuy",
    };
    additem(tempObject);
  };
  const updateItem = (id, dateValue) => {
    movetoInventory(id, "stock", dateValue);
  };
  const deleteFunction = (id) => {
    deleteItem(id);
  };
  const value = {
    inventoryContext,
    setInventoryContext,
    unitsContext,
    setUnitsContext,
    toBuyContext,
    setToBuyContext,
    addNewItem,
    updateItem,
    deleteFunction,
  };

  return (
    <InventoryContext.Provider value={value}>
      {children}
    </InventoryContext.Provider>
  );
};
